<template>
  <div class="hero-slider">
    <div
      class="hero-slider__wrapper"
      ref="slider"
    >
      <div class="hero-slider__container">
        <a
          class="hero-slider__slide"
          v-for="(slide, index) in slides"
          :key="`slide-${index}`"
          :title="slide.image.title"
          :href="slide.url"
          :target="slide.link.openInNewWindow ? '_blank' : ''"
          :data-swiper-autoplay="slide.autoplayTime ? slide.autoplayTime : 3500"
        >
          <div class="hero-slider__img-container">
            <img
              class="hero-slider__img"
              :src="slide.image.src"
              :alt="slide.image.alt ? slide.image.alt : ''"
              :width="slide.image.width"
              :height="slide.image.height"
              :loading="slide.removeLazyLoad ? 'eager' : 'lazy'"
            >
          </div>
          <div class="hero-slider__text-container">
            <div class="hero-slider__content">
              <div
                v-if="slide.headline"
                class="hero-slider__headline"
                v-html="slide.headline"
              />
              <div
                v-if="slide.copy"
                class="hero-slider__copy"
                v-html="slide.copy"
              />
            </div>
            <div class="hero-slider__pseudo-button">
              <span
                v-if="slide.subHeadline"
                class="hero-slider__subheadline button button--alt"
                v-html="slide.subHeadline"
              />
            </div>
          </div>
        </a>
      </div>
    </div>
    <a
      v-if="slides.length > 1"
      href="#"
      class="hero-slider__button hero-slider__button--prev"
      :aria-label="$t('hero.slider.prev.button.label')"
      ref="buttonPrev"
    />
    <a
      v-if="slides.length > 1"
      href="#"
      class="hero-slider__button hero-slider__button--next"
      :aria-label="$t('hero.slider.next.button.label')"
      ref="buttonNext"
    />
    <div
      v-if="slides.length > 1"
      class="hero-slider__pagination"
    >
      <a
        href="#"
        class="hero-slider__pagination-button"
        :class="{
          'hero-slider__pagination-button--active': index === activeSlide
        }"
        v-for="(slide, index) in slides"
        :key="`${index}-button`"
        @click.prevent="changeSlide(index)"
      >
        <span class="hero-slider__pagination-count">{{ index + 1 }}</span> {{ slide.headline }}
        <span
          class="hero-slider__pagination-progress-bar"
          :style="`transition-duration: ${slide.autoplayTime ? slide.autoplayTime / 1000 : '3.5'}s;`"
        />
      </a>
    </div>
  </div>
</template>

<script>
  import { Autoplay, Navigation, Swiper } from 'swiper';
  import swiperMixin from "../../utilities/vueMixins/swiperMixin/swiperMixin";

  export default {
    props: {
      slides: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    mixins: [
      swiperMixin
    ],
    data() {
      return {
        activeSlide: null
      };
    },
    mounted() {
      if (this.slides.length > 1) {
        this.createSwiperInstance();
      }
    },
    methods: {
      createSwiperInstance() {
        Swiper.use([Navigation, Autoplay]);

        this.swiperInstance = new Swiper(this.$refs.slider, {
          slidesPerView: 1,
          loop: true,
          autoplay: {
            disableOnInteraction: false
          },
          simulateTouch: this.isSimulateTouch,
          speed: 600,
          wrapperClass: 'hero-slider__container',
          slideClass: 'hero-slider__slide',
          slideActiveClass: 'hero-slider__slide--active',
          centeredSlides: true,
          navigation: {
            nextEl: this.$refs.buttonNext,
            prevEl: this.$refs.buttonPrev,
          }
        });

        this.swiperInstance.on('slideChangeTransitionEnd', this.slideChangeHandler.bind(this));
        this.activeSlide = 0;
      },
      slideChangeHandler() {
        this.activeSlide = this.swiperInstance.realIndex;
      },
      changeSlide(slideIndex) {
        this.swiperInstance.slideTo(slideIndex + 1);
      }
    }
  };

</script>
